module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Tools/Brush-6a45663ba9c07e80be2d46a39b8b5947.svg";